module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-40.c461fb56.svg";